import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/newsfeed/ArticleSearch/ArticleSearchSkeleton/articleSearchSkeleton.consts';

export const ArticleContentSkeleton = () => (
  <ContentLoader height={80} viewBox="0 0 400 100" {...DEFAULT_SETTINGS}>
    <rect x="0" y="5" rx="0" ry="0" width="300" height="10" />
    <rect x="0" y="25" rx="0" ry="0" width="400" height="10" />
    <rect x="0" y="45" rx="0" ry="0" width="350" height="10" />
  </ContentLoader>
);
